import React from 'react';
import { PageHeader } from '../components/Shared';
import { useLang } from '../context/LanguageContext';
import { useDemoRequest } from '../hooks/useDemoRequest';
import { WorkflowAgenda } from '../components/experience/WorkflowAgenda';
import { DemoRequestForm } from '../components/demo/DemoRequestForm';
import { DemoRequestSuccess } from '../components/demo/DemoRequestSuccess';
import '../styles/positioning.css';

export default function BookDemo() {
  const { t } = useLang();
  const request = useDemoRequest(t.UI.demo);
  return <div className="workflow-demo-page">
    <PageHeader eyebrow={t.DEMO.eyebrow} title={t.DEMO.title} subtitle={t.DEMO.subtitle} />
    <section className="bg-white py-14 md:py-16"><div className="mx-auto max-w-6xl px-6">
      <div className="grid items-start gap-14 lg:grid-cols-2"><WorkflowAgenda />
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-[0_20px_60px_-20px_rgba(15,23,42,0.12)]">
          {request.submitted ? <DemoRequestSuccess request={request} copy={t.UI.demo} /> : <DemoRequestForm request={request} copy={t.UI.demo} offer={t.OFFER} />}
        </div>
      </div><p className="demo-legal-note" data-testid="demo-ai-limitations">{t.OFFER.legalNote}</p>
    </div></section>
  </div>;
}